import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dhb-handball-net/dhb-handball-net/web/components/GhostPage.tsx");
